module.exports = __webpack_public_path__ + "img/d7e757d.png";